import { configureStore } from '@reduxjs/toolkit';
import jobDetailsReducer from 'src/redux/job-details/slice';

export const store = configureStore({
  reducer: {
    jobDetails: jobDetailsReducer, // Add all your slices here
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
